module.exports = __webpack_public_path__ + "ed81f3769a9cb278f0795e5e18cabbe3.png";